<script setup lang="ts">
import LoadingSkeletonRow from '@/components/LoadingSkeletonRow.vue'

const PLACEHOLDER_CARD_COUNT = 3
</script>

<template>
  <div>
    <LoadingSkeletonRow class="my-4" width="w-[400px] max-w-full" height="h-2" border-radius="rounded-sm" />
    <div class="flex flex-col md:flex-row md:gap-2">
      <LoadingSkeletonRow
        v-for="card in PLACEHOLDER_CARD_COUNT"
        :key="card"
        data-testid="goal-card-skeleton"
        width="w-full md:w-1/4"
        height="h-[220px]"
        border-radius="rounded-xxs"
      />
    </div>
  </div>
</template>
